var path = 'app/scripts/modules/core/src/whatsNew/whatsNew.directive.modal.html';
var html = "\n<div modal-page>\n  <form name=\"form\" >\n    <modal-close dismiss=\"$dismiss()\"></modal-close>\n    <div class=\"modal-header\">\n      <h3>What's New</h3>\n    </div>\n    <div class=\"modal-body\" style=\"overflow-y: scroll; height: 350px;\">\n      <div ng-bind-html=\"fileContents\"></div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-default\" ng-click=\"$dismiss()\">Close</button>\n    </div>\n\n  </form>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/whatsNew/whatsNew.directive.modal.html
// module id = 1087
// module chunks = 0